import { Component, DestroyRef, inject, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { API, LocationFullDTO } from 'src/app/services/api/api';
import { ErrorService } from 'src/app/services/error.service';
import { UtilService } from 'src/app/services/util.service';
import { TableWrapperOptions } from '../../../../services/global/global-interfaces';
import { PermissionService } from '../../../../services/permission.service';
import { StringTransformationService } from 'src/app/services/transformation-helper/string-transformation.service';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { finalize, take } from 'rxjs/operators';

@Component({
  selector: 'sb-page-company-details-locations',
  templateUrl: './company-details-locations.component.html',
  styleUrls: ['./company-details-locations.component.scss'],
  standalone: false,
})
export class CompanyDetailsLocationsComponent implements OnInit {
  readonly stringTransformation = inject(StringTransformationService);
  private readonly destroyRef = inject(DestroyRef);

  companyId: number;
  loading: boolean;
  locations: LocationFullDTO[];
  debounceTimer: ReturnType<typeof setTimeout>;

  options: TableWrapperOptions;

  constructor(
    private readonly api: API,
    private readonly activatedRoute: ActivatedRoute,
    public readonly util: UtilService,
    public readonly errorHandler: ErrorService,
    public readonly permissionService: PermissionService
  ) {
    this.companyId = undefined;
    this.loading = true;
    this.locations = [];
    this.debounceTimer = null;
  }

  ngOnInit() {
    this.activatedRoute.parent.params.subscribe(params => {
      this.companyId = +params.companyID;
    });
  }

  getCompanyId() {
    const arr = [];
    arr.push(this.companyId);
    return JSON.stringify(arr);
  }

  requestDebounced(options?: TableWrapperOptions) {
    if (options) {
      this.options = options;
    }

    if (this.debounceTimer) {
      clearTimeout(this.debounceTimer);
    }
    this.debounceTimer = setTimeout(() => {
      this.refreshFromServer();
    }, 500);
  }

  refreshFromServer() {
    this.loading = true;
    if (this.companyId && this.options?.pagination) {
      this.api
        .ss_fm_Location_retrieveAll(
          {
            search: this.stringTransformation.encodeSearchQueryParam(this.options.exactMatch, this.options.search),
            manager: [this.companyId],
          },
          this.options.pagination
        )
        .pipe(
          take(1),
          takeUntilDestroyed(this.destroyRef),
          finalize(() => {
            this.loading = false;
          })
        )
        .subscribe({
          next: (res: LocationFullDTO[]) => {
            this.locations = res;
          },
          error: error => {
            this.errorHandler.errorHandler(error);
          },
        });
    }
  }
}
